import React from 'react';
import { isOnPath } from '../../store/apiWrapper';
import SearchResultsHeader from '../headers/searchResultsHeader';
import ReportHeader from '../headers/reportHeader';
import MergeHeader from '../headers/mergeHeader';
import NewsHeader from '../headers/newsHeader';
import CeeSearchHeader from '../headers/ceeSearchHeader';
import MarketingListHeader from '../headers/marketingListSearchHeader';
import LiensSearchHeader from '../headers/liensSearchHeader';
import BankcruptcySearchHeader from '../headers/bankruptcySearchHeader';
import IndustryAnalysisHeader from '../headers/industryAnalysisHeader';
import SkyMinderHeader from '../headers/skyminderHeader';
import SearchHeader from '../headers/searchHeader';
import UserDetailsHeader from '../headers/userDetailsHeader';
import MonitoringHeader from '../headers/monitoringHeader';
import PropertyCzHeader from '../headers/propertyCzHeader';
import PropertySkHeader from '../headers/propertySkHeader';
import RatioBookHeader from '../headers/ratioBookHeader';
import MspSearchHeader from '../headers/mspSearchHeader';

import ConflictHeader from '../headers/conflictOfInterestHeader';
import ContactHeader from '../headers/contactHeader';
import PersonalDataHeader from '../headers/personalDataHeader';
import RelatedAddressHeader from '../headers/relatedAddressHeader';
import QuickReportHeader from '../headers/quickReportHeader';
import BusinessBulletinSearchHeader from '../headers/businessBulletinSearchHeader';
import relationsSearchHeader from '../headers/relationsSearchHeader';
import RepiHeader from '../headers/repiHeader';

import './topPanel.scss';
import WarningsReportHeader from '../headers/warningsReportHeader';

class TopPanel extends React.Component {
    headers = [
        { isOnPath: () => isOnPath({ regex: /(search\/results)/i }), header: SearchResultsHeader },
        { isOnPath: () => isOnPath({ regex: /\/(relation-chart)\/(\d+,).*/i }), header: MergeHeader },
        { isOnPath: () => isOnPath({ prefix: 'repi' }), header: RepiHeader },
        { isOnPath: () => isOnPath({ prefix: 'repi/report' }), header: RepiHeader },
        { isOnPath: () => isOnPath({ regex: /\/(((report)\/([\w-]+))|(relation-chart))\/(\d+).*/i }), header: ReportHeader },
        { isOnPath: () => isOnPath({ prefix: '/warnings' }), header: WarningsReportHeader },

        { isOnPath: () => isOnPath({ regex: /(unlimited\/quick)/i }), header: QuickReportHeader },
        { isOnPath: () => isOnPath({ prefix: '/news' }), header: NewsHeader },
        { isOnPath: () => isOnPath({ prefix: '/news-notifications' }), header: NewsHeader },
        { isOnPath: () => isOnPath({ regex: /\/search\/(cee|cre|aml|rpve)\/.*/i }), header: CeeSearchHeader },
        { isOnPath: () => isOnPath({ prefix: '/unicorn' }), header: MarketingListHeader },
        { isOnPath: () => isOnPath({ prefix: '/search/liens' }), header: LiensSearchHeader },
        { isOnPath: () => isOnPath({ prefix: '/search/bankruptcy' }), header: BankcruptcySearchHeader },
        { isOnPath: () => isOnPath({ prefix: '/search/businessBulletin'}), header: BusinessBulletinSearchHeader },
        { isOnPath: () => isOnPath({ prefix: '/search/property-cz' }), header: PropertyCzHeader },
        { isOnPath: () => isOnPath({ prefix: '/search/property-sk' }), header: PropertySkHeader },
        { isOnPath: () => isOnPath({ prefix: '/search/industry-analysis' }), header: IndustryAnalysisHeader },
        { isOnPath: () => isOnPath({ prefix: '/search/ratiobook' }), header: RatioBookHeader },
        { isOnPath: () => isOnPath({ prefix: '/search/conflictOfInterest' }), header: ConflictHeader },
        { isOnPath: () => isOnPath({ prefix: '/search/relations' }), header: relationsSearchHeader },
        { isOnPath: () => isOnPath({ prefix: '/search/customizable-msp' }), header: MspSearchHeader },
        { isOnPath: () => isOnPath({ regex: /search/i }), header: SearchHeader },
        { isOnPath: () => isOnPath({ prefix: '/skyminder' }), header: SkyMinderHeader },
        { isOnPath: () => isOnPath({ prefix: '/user' }), header: UserDetailsHeader },
        { isOnPath: () => isOnPath({ prefix: '/contact' }), header: ContactHeader },
        { isOnPath: () => isOnPath({ prefix: '/personal-data' }), header: PersonalDataHeader },
        { isOnPath: () => isOnPath({ prefix: '/monitoring' }), header: MonitoringHeader },
        { isOnPath: () => isOnPath({ regex: /related-address/i }), header: RelatedAddressHeader }
    ]

    render() {
        let headerInfo = this.headers.find(i => i.isOnPath());
        if (!headerInfo) { return null; }

        let Header = headerInfo.header;
        return (
            <Header {...this.props} />
        );
    }
}

export default TopPanel;